import { Grid } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import { TraderContainer } from '../../Entities.style'
import { ButtonAddNew, TraderItem, TraderTitle } from '../EntitesSide.style'
import { useDispatch } from 'react-redux'
import { setModal } from '../../../../redux/slices/Modal/modalSlice'
import { METHODS, MODAL_TITLE, MODAL_TYPE } from '../../../../utils/constants'

const Traders = ({
  traders,
  entityName,
  userType,
  showAddNewButton,
  handleTraderClicked,
  clientMmId
}) => {
  const dispatch = useDispatch()

  const createNewTrader = () => {
    dispatch(
      setModal({
        type: MODAL_TYPE.TRADER,
        title: MODAL_TITLE.NEW_TRADER,
        isOpen: true,
        method: METHODS.POST,
        data: { entity_name: entityName }
      })
    )
  }
  const handelTraderContainerClick = index => {
    handleTraderClicked(traders.data[index].name, traders.data[index].id)
  }

  return (
    <>
      <Grid style={{ marginTop: '32px', display: 'flex', justifyContent: 'space-between' }}>
        <TraderTitle>Traders</TraderTitle>
        {showAddNewButton() && <ButtonAddNew onClick={createNewTrader}>Add New</ButtonAddNew>}
      </Grid>
      <Grid>
        {!traders.status ? (
          <></>
        ) : traders.data.length > 0 ? (
          traders.data.map((key, index) => {
            return (
              <TraderContainer
                key={key}
                index={String(index)}
                length={String(traders.length)}
                select={String(
                  Number(traders.data[index].id) === Number(clientMmId) && userType === 'trader'
                )}
                onClick={() => handelTraderContainerClick(index)}
              >
                <TraderItem
                  select={String(
                    userType === 'trader' && Number(traders.data[index].id) === Number(clientMmId)
                  )}
                >
                  {key.name}
                </TraderItem>
              </TraderContainer>
            )
          })
        ) : (
          <TraderItem> No traders currently set up for {entityName} </TraderItem>
        )}
      </Grid>
    </>
  )
}

export default React.memo(Traders)

Traders.propTypes = {
  userType: PropTypes.string,
  clientMmId: PropTypes.number,
  showAddNewButton: PropTypes.func,
  traders: PropTypes.object,
  entityName: PropTypes.string,
  handleTraderClicked: PropTypes.func
}
